import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Mail, Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export const EmailSenderCard = () => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/email-status").then((r) => setS(r.data)).catch(() => {}); }, []);

  const test = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/email-test");
      setS(data);
      toast.success(`Test email sent to ${data.sent_to} from ${data.active}`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Test failed"); }
    finally { setBusy(false); }
  };

  if (!s) return null;
  const onVerified = s.verified === true;
  return (
    <div data-testid="email-sender-card" className="bg-[#121212] border border-[#2a2a2a] rounded-2xl p-5 mb-6 flex flex-wrap items-center gap-4 justify-between">
      <div className="flex items-start gap-3 min-w-0">
        <Mail className="w-5 h-5 text-[#e2ff31] mt-0.5 shrink-0" />
        <div className="min-w-0">
          <p className="text-sm">Receipts &amp; download emails send from{" "}
            <span data-testid="email-sender-active" className="font-mono text-[#e2ff31]">{s.active}</span></p>
          <p data-testid="email-sender-state" className={`text-xs mt-0.5 flex items-center gap-1 ${onVerified ? "text-[#22c55e]" : "text-[#9ca3af]"}`}>
            {onVerified ? <><CheckCircle2 className="w-3.5 h-3.5" /> {s.preferred} is verified and active</>
              : s.verified === false ? <><AlertTriangle className="w-3.5 h-3.5 text-[#f59e0b]" /> {s.preferred} isn't verified yet — using {s.fallback}. Switches automatically once verified.</>
              : <>Will use {s.preferred || s.fallback} automatically once its domain is verified at Resend.</>}
          </p>
        </div>
      </div>
      <button data-testid="email-sender-test" onClick={test} disabled={busy || !s.configured}
        className="rounded-full border border-[#2a2a2a] hover:border-[#e2ff31]/60 hover:text-[#e2ff31] text-sm font-semibold px-4 py-2 transition-colors flex items-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Send test email
      </button>
    </div>
  );
};
